module.exports = __webpack_public_path__ + "img/dcoin.88f4968a.jpg";